<template>
  <div v-if="order">
    <p><strong>Заказ #{{order.ID}} от {{order.DATE_INSERT}}</strong></p>
    <p>{{order.PAY_SYSTEM_NAME}}</p>
    <p>{{order.ADDRESS.LOCATION.DISPLAY}}, ул. {{order.ADDRESS.STREET}}, д. {{order.ADDRESS.HOUSE}}{{ order.ADDRESS.BUILDING ? ` к. ${order.ADDRESS.BUILDING}` : ''}}{{ order.ADDRESS.APARTMENTS ? `, кв. ${order.ADDRESS.APARTMENTS}` : ''}}</p>
    <p v-html="order.TOTAL_PRICE_FORMATTED"></p>
    <p>{{order.STATUS_NAME}}</p>

    <div v-for="payment in order.PAYMENTS" :key="payment.ID">
      <div v-if="payment.CAN_BE_PAID" v-html="payment.BUFFERED_OUTPUT">

      </div>

    </div>
  </div>
</template>

<script>
import api from '@/api/personal'

export default {
  name: 'ProfileOrderHistoryDetail',
  props: {
    orderId: {
      type: String,
    },
  },
  data: function () {
    return {
      order: null,
    };
  },
  mounted() {
    api.loadOderDetail(this.orderId, (response) => this.order = response.order ?? {});
  }
};
</script>